import FullWidthEmbed from './FullWidthEmbed';

export { type FullWidthEmbedProps } from './FullWidthEmbed';
export default FullWidthEmbed;
